import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import Dictionary from "../../../domains/Dictionary";
import SystemFitness from "../../../domains/SystemFitness";
import ComponentConversion from "../../../domains/ComponentConversion";
import SystemRecommendation from "../../../domains/SystemRecommendation";

import { SLICE_NAME } from "./types";

interface CachedRecommendation {
  systemFit: Dictionary<SystemFitness>
  convertedComponents: Dictionary<ComponentConversion>
  isOnSpec: boolean
}

interface RecommendationsState {
  cachedRecommendations: CachedRecommendation | null
  selectedSystemRecommendations: Array<SystemRecommendation>
  isSystemRecommendationsModalOpen: boolean
}

const initialState: RecommendationsState = {
  cachedRecommendations: null,
  selectedSystemRecommendations: [],
  isSystemRecommendationsModalOpen: false,
};

export const recommendationsSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setRecommendations: (
      state,
      action: PayloadAction<{ recommendations: CachedRecommendation }>,
    ) => {
      state.cachedRecommendations = action.payload.recommendations;
    },
    clearRecommendations: state => {
      state.cachedRecommendations = null;
      state.selectedSystemRecommendations = [];
    },
    setSelectedSystemRecommendations: (
      state,
      action: PayloadAction<{ systemId: string; systemName: string }>,
    ) => {
      const foundIndex = state.selectedSystemRecommendations.findIndex(
        system => system.id === action.payload.systemId,
      );

      const updatedSelectedSystems =
        foundIndex === -1
          ? [
            ...state.selectedSystemRecommendations,
            { name: action.payload.systemName, id: action.payload.systemId },
          ]
          : state?.selectedSystemRecommendations.filter(
            system => system.id !== action.payload.systemId,
          );

      state.selectedSystemRecommendations = updatedSelectedSystems;
    },
    closeSystemRecommendationsModal: state => {
      state.isSystemRecommendationsModalOpen = false;
    },
    openSystemRecommendationsModal: state => {
      state.isSystemRecommendationsModalOpen = true;
    },
  },
});

export const {
  setRecommendations,
  clearRecommendations,
  setSelectedSystemRecommendations,
  closeSystemRecommendationsModal,
  openSystemRecommendationsModal,
} = recommendationsSlice.actions;

export default recommendationsSlice.reducer;
